export default "__VITE_ASSET__f793a702__"